
export class Editor {
  content: string
  constructor() {
    this.content = '';
  }
}

export class EditorConfig {

  footer: {
    show: boolean,
    saveBtn: {
      show: boolean,
      text: string
    },
    cancelBtn: {
      show: boolean,
      text: string
    };
  }

  cancelIcon: {
    show: boolean
  }

  titleBar: {
    show: boolean,
    text: string
  };

  constructor() {

    this.footer = {
      show: true,
      cancelBtn: {
        show: true,
        text: 'CANCEL'
      },

      saveBtn: {
        show: true,
        text: 'SAVE'
      }

    }


    this.cancelIcon = {
      show: true
    };


    this.titleBar = {
      show: true,
      text: 'Editor'
    };
  }
}